import { TWorkflowEventDescriptor } from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { WORKFLOW_EVENT_BASE_URL } from './helpers';

export const useEventDescriptor = (eventType: string | null) => {
  const url = eventType ? `${WORKFLOW_EVENT_BASE_URL}/${eventType}` : null;

  const { data, error, isLoading } = useSWR<TWorkflowEventDescriptor>(
    url,
    url ? SWRFetcher({ method: 'GET' }) : null
  );

  return { data, error, isLoading };
};
